import React, { useEffect, useState } from "react";
import axios from "axios";
import NotesView from "../../order/components/Quote/Notes/NotesView";

const NotesTab = ({ user, afterSubmit }) => {
  const [privateNote, setPrivatNote] = useState(user?.private_note || "");
  const [personalizationNote, setPersonalizationNote] = useState(
    user?.personalization_note || ""
  );

  const onChangePrivateNote = async (privateNote) => {
    const response = await axios.put(`/api/users/${user.id}/private-note`, {
      note: privateNote,
    });

    setPrivatNote(privateNote);
  };

  const onPersonalizationNotechange = async (personalizationNote) => {
    const response = await axios.put(
      `/api/users/${user.id}/personalization-note`,
      {
        note: personalizationNote,
      }
    );

    setPersonalizationNote(personalizationNote);
  };

  const fetchUser = async () => {
    const { data } = await axios.get(`/api/users/${user.id}`);
    setPrivatNote(data.user.private_note);
    setPersonalizationNote(data.user.personalization_note);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="kyc">
      <div className="row m-1 g-3">
        <div className={`col-12 col-6 col-lg-6  col-md-12`}>
          <h4 className="text-center mb-2">Private</h4>
          <NotesView notes={privateNote} onChange={onChangePrivateNote} />
        </div>
        <div className={`col-12 col-6 col-lg-6  col-md-12`}>
          <h4 className="text-center mb-2">AI personalization</h4>
          <NotesView
            notes={personalizationNote}
            onChange={onPersonalizationNotechange}
          />
        </div>
      </div>
    </div>
  );
};

export default NotesTab;
